<div class="slogan">
  <mds-icon [height]="36" [key]="currentTheme.icon" [pathColors]="['#fff']" [width]="36"></mds-icon>
  <h5>{{ currentTheme.slogan }}</h5>
</div>

<div class="modal">
  <div class="modal__header">
    <img alt="logo" src="./assets/images/login/makersite-logo.svg" />
  </div>
  <div class="modal__content">
    @if (signIns && signIns.length > 0) { @for (ss of signIns; track ss; let i = $index) {
    <div class="sso">
      <button
        (click)="onSingleSignIn(ss)"
        matTooltipHideDelay="300"
        [matTooltip]="'Sign in with ' + ss.name"
        mat-button
        role="button"
      >
        <img
          [alt]="ss.name"
          [ngClass]="{ 'makersite-logo-white': ss.logo?.includes('makersite.svg') }"
          [src]="ss.logo?.includes('makersite.svg') ? '/assets/images/logos/makersite-white.svg' : ss.logo"
        />
        <div>
          <span>1 Click Access</span>
        </div>
      </button>
    </div>
    }
    <div class="sso-or">OR</div>
    }

    <h4 class="title">{{ isLoginForm ? 'Log In' : 'Reset your password' }}</h4>
    @if (isLoginForm) {
    <form (ngSubmit)="onSubmit()" [formGroup]="loginForm" name="loginForm" novalidate>
      <div>
        <mat-label>Username or email</mat-label>
        <mat-form-field appearance="outline">
          <input
            data-testid="email"
            formControlName="email"
            matInput
            name="email"
            placeholder="Email address"
            type="email"
          />
          @if (loginForm.controls.email?.touched && loginForm.controls.email?.errors?.required) {
          <mat-error aria-live="assertive" class="login-hint" role="alert">Email field is required</mat-error>
          } @if (loginForm.controls.email?.touched && loginForm.controls.email?.errors?.pattern) {
          <mat-error aria-live="assertive" class="login-hint" role="alert">
            Email must be a valid e-mail address
          </mat-error>
          }
        </mat-form-field>
      </div>
      <div>
        <mat-label>Password</mat-label>
        <mat-form-field appearance="outline">
          <input
            data-testid="password"
            formControlName="password"
            matInput
            name="password"
            placeholder="Password"
            type="password"
          />
          @if (loginForm.controls.password?.touched && loginForm.controls.password?.errors?.required) {
          <mat-error aria-live="assertive" class="login-hint" role="alert">Password field is required</mat-error>
          }
        </mat-form-field>
      </div>
      <div>
        <mds-checkbox formControlName="remember" size="small">Remember me</mds-checkbox>
      </div>
      <mds-button aria-label="Log In User Account" type="primary" [attr.data-testid]="'Log in'">Log in</mds-button>
      <a (click)="onForgotPassword()" class="forgot-password">Forgot password?</a>
    </form>
    } @if (!isLoginForm) {
    <form (ngSubmit)="onForgotPasswordSubmit()" [formGroup]="forgotPasswordForm" name="loginForm" novalidate>
      <div>
        <mat-label>Email address</mat-label>
        <mat-form-field appearance="outline">
          <input
            data-testid="email"
            formControlName="email"
            matInput
            name="email"
            placeholder="Email address"
            type="email"
          />
          @if (forgotPasswordForm.controls.email?.touched && forgotPasswordForm.controls.email?.errors?.required) {
          <mat-error aria-live="assertive" class="login-hint" role="alert">Email field is required</mat-error>
          } @if (forgotPasswordForm.controls.email?.touched && forgotPasswordForm.controls.email?.errors?.pattern) {
          <mat-error aria-live="assertive" class="login-hint" role="alert">
            Email must be a valid e-mail address
          </mat-error>
          }
        </mat-form-field>
      </div>
      <mds-button class="submit-btn" aria-label="Send reset link" type="primary">Send reset link</mds-button>
      <a (click)="isLoginForm = true" class="back-to-login">Back to login</a>
    </form>
    }
  </div>
  <div class="modal__more">
    <p>Want to know more?</p>
    <p>
      Visit our website at
      <a href="https://www.makersite.io" target="_blank">www.makersite.io</a>
    </p>
  </div>
</div>
